import EligibilityGuard from 'app/PemetaanKompetensiPage/components/EligibilityGuard'
import RefleksiKompetensiErrorBoundary from 'app/PemetaanKompetensiPage/components/RefleksiKompetensiErrorBoundary'
import Form from 'app/PemetaanKompetensiPage/pages/AsesmenRefleksi/Form'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer },
  }
}

const PageAsesmenRefleksiForm = ({ currentDateTimeServer }) => (
  <RefleksiKompetensiErrorBoundary withHeader>
    <EligibilityGuard currentDateTimeServer={currentDateTimeServer}>
      <Form currentDateTimeServer={currentDateTimeServer} />
    </EligibilityGuard>
  </RefleksiKompetensiErrorBoundary>
)

PageAsesmenRefleksiForm.layoutOpts = {
  className: 'text-default bg-white !max-w-full',
}

export default PageAsesmenRefleksiForm
